module.exports = __webpack_public_path__ + "img/default-user-icon.7126445c.svg";